import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setChoiceAddressFormAction } from "../../redux/actions";

const ChoiceAddressForm = () => {
    const dispatch = useDispatch();
    const choice_address_form = useSelector(state => state.choice_address_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setChoiceAddressFormAction({
                                    ...choice_address_form,
                                    open: false
                                }));
                            } }
                        />
                        <div className="form__title">Выбор адреса</div>
                    </div>

                    <div className="form__field">
                        {
                            choice_address_form.addresses.map(elem => {
                                return (
                                    <div key={ elem.id } className="service schedule__item"
                                        onClick={ () => {
                                            window.location.href = elem.link;
                                        } }
                                    >
                                        <div className="service__name">{ elem.address }</div>
                                    </div>
                                );
                            })
                        }
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ChoiceAddressForm;